(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EnvoyerMessageCommercialDialogController', EnvoyerMessageCommercialDialogController);

        EnvoyerMessageCommercialDialogController.$inject = ['$uibModalInstance', 'entity', 'commercial', 'Message', 'Principal'];

    function EnvoyerMessageCommercialDialogController($uibModalInstance, entity, commercial, Message, Principal) {

        var vm = this;
        vm.profile = entity;
        vm.commercial = commercial;
        vm.clear = clear;
        vm.confirmSend = confirmSend;

        vm.currentAccount = null;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmSend (profile) {
            console.log(profile.id);
            Message.envoyerMessageCommercial({commercialUserId : vm.commercial.id}, profile, function (result) {
                console.log(result);
            });
            $uibModalInstance.close();
        }
    }
})();
